import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(shop)/category/error.tsx");
